<div class="input-group" style="width: 300px;">
    <span class="input-group-text">
        <ng-icon name="lucideSearch"></ng-icon>
    </span>
    <input [(ngModel)]="term" (ngModelChange)="search()" type="text" class="form-control"
           placeholder="Search suppliers, locations..." />
    @if (term) {
    <button class="btn btn-outline-secondary" type="button" (click)="clearTerm()" title="Clear search">
        <ng-icon name="lucideX"></ng-icon>
    </button>
    }
</div>
